// @ts-expect-error file not migrated yet
import propertyValueToNumber from 'customer-data-sidebar/universal/dataAccessHelpers/propertyValueToNumber';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { DISPLAY_LABEL_FALLBACK } from '../../../constants/displayLabelFallback';
import { Flex } from 'foundations-components/components/Flex';
import { SecondaryPropertyLabel } from '../../../card/secondaryProperties/SecondaryPropertyDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useGetCustomerSuccessAlertChickletSecondaryDisplayLabels = ({
  properties
}) => {
  const alertCreateDate = propertyValueToNumber(getPropertyValueFromProperties(properties, 'hs_createdate'));
  const renderCreateDate = () => {
    const dateText = alertCreateDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
      value: alertCreateDate,
      type: "userTz",
      format: "LL"
    }) : DISPLAY_LABEL_FALLBACK;
    return /*#__PURE__*/_jsxs(Flex, {
      "data-selenium-test": "cs-alert-chicklet-create-date",
      "data-test-id": "cs-alert-chicklet-create-date",
      children: [/*#__PURE__*/_jsx(SecondaryPropertyLabel, {
        propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.AlertChickletSecondaryPropertyLabels.createDate"
        })
      }), dateText]
    });
  };
  const propertyFormatters = {
    /* For portals other than 53, we can display the default value of hs_pipeline_stage.
    This is because all the other portals have only one pipeline and doesn't confuse the users
    if the pipeline name is visible.*/
    hs_createdate: renderCreateDate
  };
  return {
    propertyFormatters,
    copyDisabled: false
  };
};
export default useGetCustomerSuccessAlertChickletSecondaryDisplayLabels;